<template>
  <v-layout row wrap>
    <v-flex xs12>
      <div class="gui-flex">
        <div class="gui-flex-fill-rest">
          <v-text-field slot="activator" v-model="date_text" mask="##.##.####" ref="textField" :label="label" :rules="dateRules" :clearable="clearable" :hide-details="hideDetails" @change="proccessChange"></v-text-field>
        </div>
        <div class="pt-3 pr-3">
          <v-menu ref="menu" :close-on-content-click="false" v-model="menu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <v-icon slot="activator">event</v-icon>
            <v-date-picker ref="picker" v-model="date" locale="cs-cz" first-day-of-week="1"></v-date-picker>
          </v-menu>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: function () {
    return {
      stavy: [],
      stav: null,
      menu: false,
      date: null,
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno",
        (v) => moment(v, "DD.MM.YYYY")._isValid || "Datum není zadán správně"
      ],
      dateRules: [],
      rulesCanBeEmpty: [
        (v) => !v || moment(v, "DD.MM.YYYY")._isValid || "Datum není zadán správně"
      ],
      date_text: ""
    }
  },
  props: {
    value: Number,
    label: String,
    clearable: Boolean,
    rules: Boolean,
    hideDetails: Boolean
  },
  watch: {
    date_text (v) {
      if (v == "") {
        this.$emit("input", null);
        this.menu = false
      }
      else {
        var $m = moment(v, "DD.MM.YYYY");
        if ($m._isValid && v.length == 8 && this.$refs.textField.$refs.input == document.activeElement) {
          this.$emit("input", parseInt($m._d.getTime()/1000)-new Date().getTimezoneOffset()*60)
        }
      }
    },
    date (v) {
      if (v == null) {
        this.$emit("input", null);
        this.menu = false
      }
      else {
        this.$emit("input", parseInt(new Date(this.date).getTime()/1000))
        this.date_text = moment(new Date(this.date)).format("DD.MM.YYYY")
        this.menu = false
      }
      //this.$emit("input", parseInt(new Date(this.date + " 00:00:00").getTime()/1000)+new Date().getTimezoneOffset()*60)
      //this.menu = false
    }
  },
  mounted: function() {
    if (this.value != null && this.value > 0) {
      this.date = new Date(this.value*1000).toISOString().substr(0, 10)
    }
    if (!this.$props.rules)
      this.dateRules = this.rulesCanBeEmpty
    else
      this.dateRules = this.rulesRequired
  },
  methods: {
    proccessChange () {
      var $m = moment(this.date_text + " 00:00:00", "DDMMYYYY HH:mm:ss")
      if ($m._isValid && this.date_text.length == 8) {
        this.$emit("input", parseInt($m._d.getTime()/1000)-$m._d.getTimezoneOffset()*60)
      }
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
